module.exports = __webpack_public_path__ + "static/media/recipes-all-1-min.8f114ce1.png";